// section four
import { FC, useState } from 'react'
import PdForm, { FieldItem } from '../../components/pd-atom-form/pd-atom-form'
import { submitForm } from '../../service/form.service'
import toast, { Toaster } from 'react-hot-toast'
import { useRouter } from 'next/router'
import { FieldValues } from 'react-hook-form'

const FormFields: FieldItem[] = [
  {
    type: 'INPUT',
    label: 'Name',
    fieldName: 'name',
    placeholder: 'Please enter',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: 'Your Email',
    fieldName: 'email',
    placeholder: 'Please enter',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: 'Your Company / Organization Name',
    fieldName: 'companyName',
    placeholder: 'Please enter',
    rule: { required: true },
    className: '!col-span-2',
  },
  {
    type: 'INPUT',
    label: 'How to describe your business in the best way? (Restaurant, Hospital, Library, Office, etc.)',
    fieldName: 'careerBackground',
    placeholder: 'Please enter',
    rule: { required: false },
    className: '!col-span-2',
  },
  {
    type: 'INPUT',
    label: 'Your Job Title (Owner, GM, Director etc.)',
    fieldName: 'jobTitle',
    placeholder: 'Please enter',
    rule: { required: false },
  },
  {
    type: 'INPUT',
    label: 'Your Phone number(Cell phone preferred)',
    fieldName: 'mobile',
    placeholder: 'Please enter',
    rule: { required: true },
  },

  {
    type: 'TEXT',
    label: 'Other information you want us to know',
    placeholder: 'Please enter',
    fieldName: 'message',
  },
]

const defaultFormValue = {}

const SectionForm: FC = () => {
  const [agree, setAgree] = useState(0)
  const router = useRouter()

  function handleSubmit(values: FieldValues) {
    submitForm({
      name: values.name,
      email: values.email,
      company: values.companyName,
      mobile: values.mobile,
      address: values.address,
      careerBackground: values.careerBackground,
      jobTitle: values.jobTitle,
      remark: `用户留言: ${values.message}. (美国德州试用活动)`,
      countryCode: 'US',
    })
      .then((res) => {
        if (res.code === 200 || res.code === 0) {
          router.push(
            {
              pathname: '/contact-us/success',
              query: {
                email: values.email,
                phone: values.mobile,
                name: values.name,
                formId: 'texasbellabot',
              },
            },
            '/contact-us/success'
          )
        } else {
          const error = res.message
          toast.error(error)
        }
      })
      .catch((res) => {
        const response = res.response?.data
        if (response && response.message) {
          const error = response.message
          toast.error(error)
        } else {
          toast.error(res)
        }
      })
  }

  return (
    <section id="form" className="w-full bg-white pb-15 laptop:py-30 px-6 laptop:px-0">
      <div className="w-full max-w-300 flex flex-col laptop:flex-row justify-between mx-auto gap-8 laptop:gap-35">
        <h2 className="text-24 laptop:text-5xl font-semibold text-[#fc7216] shrink-0">Contact</h2>

        <div className="w-full laptop:w-744px ">
          <div className="flex flex-col laptop:flex-row justify-between pb-8 laptop:pb-12 border-b border-solid border-[#c2c2c2]">
            <div>
              <p className="text-black/60 text-14 laptop:text-sm font-semibold">Phone Number</p>
              <a className="text-24 laptop:text-3xl font-semibold text-black/90" href="tel:+1 2135635992">
                +1 2135635992
              </a>
            </div>
            <div className="mt-6 laptop:mt-0">
              <p className="text-black/60 text-14 laptop:text-sm font-semibold">E-mail</p>
              <a className="text-24 laptop:text-3xl font-semibold text-black/90" href="mailto:leo.peng@pudutech.com">
                leo.peng@pudutech.com
              </a>
            </div>
          </div>

          {/* form part */}

          <div className="pt-3 laptop:pt-4">
            <p className="text-14 laptop:text-16 text-black/60 font-normal">
              Fill the Form to Complete the BellaBot TRIAL Application Please fill in the relevant information, we will
              contact you ASAP.
            </p>

            <div className="mt-6">
              <PdForm
                fields={FormFields}
                defaultFormValues={defaultFormValue}
                onSubmit={handleSubmit}
                bottomRender={(trigger, getValues, formState, formValidity) => {
                  return (
                    <div className="mt-0">
                      <div className="flex flex-row gap-x-4">
                        <input
                          name="agree"
                          type="checkbox"
                          value={agree}
                          onChange={() => setAgree((prev) => 1 - prev)}
                        />
                        <p className="text-12 laptop:text-sm text-black/60">
                          Pudu Robotics is committed to protecting and respecting your privacy. By clicking the
                          &quot;Submit&quot;, you confirm that you have read and agreed to Pudu Robotics&apos;{' '}
                          <a target={'blank'} href="/en/privacy" className="text-pdblue">
                            Privacy Policy
                          </a>{' '}
                          . Pudu Robotics may use your information to contact you about updates and special offers. You
                          can unsubscribe at any time.
                        </p>
                      </div>

                      <input
                        className={[
                          'mt-8 laptop:mt-12 w-full laptop:w-fit laptop:px-76px py-13px laptop:py-18px rounded-full  text-white text-base laptop:text-xl cursor-pointer font-semibold',
                          agree && formValidity ? 'bg-[#fc7216]' : 'bg-d8',
                        ].join(' ')}
                        type="submit"
                        disabled={!(agree && formValidity)}
                        value="Submit"
                      />
                    </div>
                  )
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Toaster />
    </section>
  )
}

export default SectionForm
